import { forOrganisation } from '../channels';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { SENTIENCE_OUTPUT } from './topics';

export const ENTITIES_UPDATED = 'SENTIENCE/ENTITIES_UPDATED' as const;

export interface IEntitiesUpdatedPayload {
  organisationId: string;
}

export const entitiesUpdatedPayload = objectSchemaOf<IEntitiesUpdatedPayload>({
  organisationId: Joi.string().required(),
});

export interface IEntitiesUpdatedAction {
  type: typeof ENTITIES_UPDATED;
  payload: IEntitiesUpdatedPayload;
}

export const entitiesUpdatedActionSchema = objectSchemaOf<IEntitiesUpdatedAction>(
  {
    type: Joi.string().valid(ENTITIES_UPDATED).required(),
    payload: entitiesUpdatedPayload.required(),
  }
);

export const entitiesUpdated = actionCreator({
  schema: entitiesUpdatedActionSchema,
  topic: SENTIENCE_OUTPUT,
  type: ENTITIES_UPDATED,
  channels: [forOrganisation],
});
